'use client'

import React from "react";
import AppButton from "@/app/components/atomic/molecules/AppButton";
import {isPartnerLink} from "@/app/utils/partner-link";
import {useTracking} from "@/app/contexts/tracking-context";

interface IButtonBlockProps {
    target: string;
    label: string;
    size?: any;
    theme?: any;
}

// Map the legacy AppButton theme/size vocabulary (coming from the WP block config)
// onto the reduced AppButton vocabulary.
const mapThemeToNew = (theme?: string): "orange" | "whiteBlur" => {
    if (theme && (theme.startsWith("blue") || theme.startsWith("white"))) {
        return "whiteBlur"
    }
    return "orange"
}

const mapSizeToNew = (size?: string): "xs" | "sm" | "lg" => {
    switch (size) {
        case "small":
            return "xs"
        case "large":
        case "block":
            return "lg"
        default:
            return "sm"
    }
}

export default function PartnerLinkButton({target, size, theme, label}: IButtonBlockProps) {
    const { track } = useTracking();

    let buttonLink = target;

    const onButtonClick = (event: any) => {
        event.preventDefault();

        // Get the href from the button element instead of using the props
        const clickedElement = event.currentTarget;
        buttonLink = clickedElement.getAttribute('href') || target;

        if (isPartnerLink(buttonLink)) {
            // Use tracking context instead of direct dataLayer push
            track({
                event: 'gtm_partner_link_clic',
                partner_url: buttonLink,
                event_source: 'auctor_tool_partner_button'
            });
        }

        window.open(buttonLink, '_blank');
    }

    return (
        <AppButton
            href={buttonLink}
            target="_blank"
            size={mapSizeToNew(size)}
            theme={mapThemeToNew(theme)}
            wFull={size === "block"}
            noWrap
            onClick={(e) => onButtonClick(e)}
        >
            {label}
        </AppButton>
    )
}
